const crypto = require('crypto')

const API_UNAME = process.env.API_UNAME
const API_PSSWD = process.env.API_PSSWD
const API_SECRET = process.env.API_SECRET

const AUTH_PARAMS = {
    username: API_UNAME,
    password: API_PSSWD,
    secret: API_SECRET
}

export function _auth() {
    const hash = crypto.createHash('md5')
    return hash.update(AUTH_PARAMS.username + AUTH_PARAMS.password + AUTH_PARAMS.secret).digest('hex')
}



// WEBPACK FOOTER //
// ./src/service/auth.js